<template>
    <div>
        <v-container>
            <v-row>
                <v-col class="text-center">
                    <v-alert type="warning">The time off request has been denied.</v-alert>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import GuestLayout from "../../../Layouts/GuestLayout";

export default {
    name: "DenyRequest",
    layout: [GuestLayout],
}
</script>

<style scoped>

</style>
